
import { iSFAkteneingaengeResult, iSFDefaultsResult, iSFFristenResult, iSFLogoutResult, iSFScheduleResult, iSFUserResult, iSfAuthResult } from "./interfacesAPI";

// const apiRoot = '/api/';
const root = process.env.NODE_ENV === "development" ? 'https://gaertner.support:8001/' : '/';
const apiRoot = `${root}api/`;

const options: RequestInit = {
    credentials: "include"
};

async function getF(path: string) {
    try {
        const response = await fetch(apiRoot + path, options);
        try {
            const data = await response.json();
            return data;
        }
        catch (e) {
            const text = await response.text();
            return {
                success: false,
                error: "no json",
                reply: text
            };
        }
    }
    catch (e) {
        return {
            success: false,
            error: "network issue",
            reply: e
        };
    }
}

function sfauth(): Promise<iSfAuthResult> {
    return getF("sfauth");
}

function logout(): Promise<iSFLogoutResult> {
    return getF("logout");
}

function loadUser(): Promise<iSFUserResult> {
    return getF("user");
}

function loadAkteneingaenge(): Promise<iSFAkteneingaengeResult> {
    return getF(`akteneingaenge`);
}

function loadFristen(bffId: string, days: number = 30): Promise<iSFFristenResult> {
    return getF(`fristen/${bffId}/${days}`);
}

function loadDefaults(days: number): Promise<iSFDefaultsResult> {
    return getF(`defaults/${days}`);
}

function loadSchedule(bffId: string, time: number): Promise<iSFScheduleResult> {
    return getF(`schedule/${bffId}/${time}`);
}

const api = {
    apiRoot,
    sfauth,
    logout,
    loadUser,
    loadAkteneingaenge,
    loadFristen,
    loadDefaults,
    loadSchedule,
};

export default api;